import { ref } from 'vue';

interface ConfettiRef {
  setCount?: (count: number) => void;
  setFade?: (fade: boolean) => void;
  setPower?: (power: number) => void;
  setSize?: (size: number) => void;
  setYBias?: (bias: number) => void;
  triggerConfetti: (x?: number, y?: number) => void;
}

const confettiRef = ref<ConfettiRef | null>(null);

export const useConfetti = () => {
  const setConfettiTrigger = (trigger: (x?: number, y?: number) => void) => {
    if (confettiRef.value) {
      confettiRef.value.triggerConfetti = trigger;
    } else {
      confettiRef.value = { triggerConfetti: trigger };
    }
  };

  const setConfettiRef = (ref: ConfettiRef) => {
    confettiRef.value = ref;
  };

  const triggerConfetti = (x?: number, y?: number) => {
    confettiRef.value?.triggerConfetti(x, y);
  };

  const setParticleCount = (count: number) => {
    confettiRef.value?.setCount?.(count);
  };

  const setExplosionPower = (power: number) => {
    confettiRef.value?.setPower?.(power);
  };

  const setParticleSize = (size: number) => {
    confettiRef.value?.setSize?.(size);
  };

  const setFade = (fade: boolean) => {
    confettiRef.value?.setFade?.(fade);
  };

  const setYBias = (bias: number) => {
    confettiRef.value?.setYBias?.(bias);
  };

  return {
    setConfettiRef,
    setConfettiTrigger,
    setExplosionPower,
    setFade,
    setParticleCount,
    setParticleSize,
    setYBias,
    triggerConfetti,
  };
};
